module.exports = "data:image/svg+xml;base64,PHN2ZwogICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCiAgICB2aWV3Qm94PSIwIDAgMzEuNDkgMjIuMTQiCiAgPgogICAgPGc+CiAgICAgIDxwYXRoCiAgICAgICAgZD0iTTEwLjI3LjMzQTEuMTIsMS4xMiwwLDEsMSwxMS44NiwxLjlsLTgsOEgzMC4zN2ExLjEyLDEuMTIsMCwwLDEsMS4xMywxLjExLDEuMTMsMS4xMywwLDAsMS0xLjEzLDEuMTNIMy44MWw4LDhhMS4xNCwxLjE0LDAsMCwxLDAsMS41OSwxLjExLDEuMTEsMCwwLDEtMS41OSwwbC0xMC0xMGExLjEyLDEuMTIsMCwwLDEsMC0xLjU3WiIKICAgICAgLz4KICAgIDwvZz4KICA8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/remote-edu/components/top/images/back.svg
// module id = 0747a9baab757f634b76
// module chunks = 0